module.exports = __webpack_public_path__ + "static/media/Filter.892d681f.jpg";